export const cilArrowThickBottom = ["24 24","<path d='M11.985 23.186l-11.235-11.266v-1.794l6.747-0v-9.376h9v9.375l6.751-0-0.002 1.813zM2.575 11.626l9.412 9.438 9.45-9.439-6.44 0v-9.375h-6v9.376z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-arrow-thick-bottom.js
// module id = null
// module chunks = 